import { Outlet } from "react-router-dom";
const AuthLayout = () => {
  return (
    <>
      <div className="flex w-full bg-popover h-[100vh]">
        <section className="flex flex-1 flex-col justify-center items-center p-10">
          <Outlet />
        </section>
      </div>
    </>
  );
};

export default AuthLayout;
